import React from 'react';
import { SenjaReviewsContainer } from './SenjaReviews.styles';
import SenjaEmbed from './SenjaEmbed';

interface SenjaReviewsProps {
  senjaId: string;
}

const SenjaReviews = ({ senjaId }: SenjaReviewsProps): JSX.Element => (
  <SenjaReviewsContainer>
    <SenjaEmbed senjaId={senjaId} />
  </SenjaReviewsContainer>
);

export default SenjaReviews;
